<div [lang]="currentLang.slug" [class]="active ? 'popup active' : 'popup'" [dir]="currentLang.dir" 
    (click)="onPopupClick($event);">
    <div class="popup-win">
        <div class="popup-head grad">
            <div class="popup-title">{{title}}</div>
            <div class="popup-close" (click)="close();"><span></span></div>
        </div>
        <div class="popup-content">
            <div>
                <p [innerHTML]="text"></p>
            </div>
        </div>
        <div class="popup-foot">
            <button class="popup-close" (click)="close();">{{currentLang.words["close"]}}</button>
        </div>
    </div>
</div>